import { createSlice } from '@reduxjs/toolkit';

import AccountClientRequests from '../../../api/requests';
import { PublicSettingsStateType } from './publicSettings.interfaces';

const initialState: PublicSettingsStateType = {
	isEmailsAllowlistEnabled: false,
	isEmailsBlocklistEnabled: false,
};

export const { reducer: publicSettingsReducer, name: publicSettingsName } = createSlice({
	name: 'publicSettings',
	initialState,
	reducers: {},
	extraReducers: builder =>
		builder.addCase(AccountClientRequests.PublicSettings.getPublicSettings.fulfilled, (state, { payload }) => {
			state.isEmailsAllowlistEnabled = Boolean(payload.settings?.is_emails_allowlist_enabled);
			state.isEmailsBlocklistEnabled = Boolean(payload.settings?.is_emails_blocklist_enabled);
		}),
});
